import moment from 'moment';
import MasterCardImage from 'src/assets/images/cards/master.png';
import VisaCardImage from 'src/assets/images/cards/visa.png';
import Amex from 'src/assets/images/cards/amex.png';
import Jcb from 'src/assets/images/cards/jcb.png';
import Unionpay from 'src/assets/images/cards/unionpay.png';
import Blik from 'src/assets/images/cards/blik.png';
import Blank from 'src/assets/images/cards/blank.png';

export const CARD_LOGOS = {
  visa: VisaCardImage,
  mastercard: MasterCardImage,
  amex: Amex,
  unionpay: Unionpay,
  jcb: Jcb,
  blik: Blik,
  blank: Blank
};

const types = [
  {
    name: 'Visa',
    label: 'Visa',
    pattern: /^4\d{12}(\d{3}|\d{6})?$/,
    groupPattern: /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/,
    logo: CARD_LOGOS.visa
  },
  {
    name: 'Mastercard',
    label: 'Master Card',
    pattern: /^(5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)\d{12}$/,
    groupPattern: /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/,
    logo: CARD_LOGOS.mastercard
  }
];

export const cardTypes = {
  types: () => types,
  find: (card) => types.find((t) => t.pattern.test(card.cardNumber.toString())),
  cardNumberInputEagerFormat: (cardNumber) => {
    const group = (
      cardNumber.toString().match(/(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/) || []
    )
      .slice(1)
      .filter(Boolean);

    return group.join(' ');
  },
  format: (card) => {
    const type = cardTypes.find(card);
    if (!type) return null;
    const group = (card.cardNumber.toString().match(type.groupPattern) || [])
      .slice(1)
      .filter(Boolean);
    return {
      cardNumber: group
        .map((t, i) => (i === group.length - 1 ? t : ''.padEnd(t.length, '*')))
        .join(' '),
      cardHolder: card.cardHolder,
      cardExpire: moment(card.cardExpire, 'MM/YYYY'),
      cardCvv: card.cardCvv,
      cardType: type.label,
      logo: type.logo
    };
  }
};
